import { colors } from '@components/theme/styles/index';
import { styled } from '@mui/material';
import { rem } from 'polished';

export const RequestList = styled('div')({
  backgroundColor: colors.white,
  marginBottom: rem(20),
});
